import { SET_ABSCHLUSS, SET_ANZEIGEMODUS } from "./mutations.type";

import { LADE_AUSWAHLWERTE_MODULUNTERRICHT } from "./actions.type";

import AppApi from "../../api/AppApi";

export default {
  namespaced: true,
  state: {
    abschluss: [],
    anzeigemodus: [],
  },
  mutations: {
    [SET_ABSCHLUSS](state, val) {
      state.abschluss = val;
    },
    [SET_ANZEIGEMODUS](state, val) {
      state.anzeigemodus = val;
    },
  },
  actions: {
    async [LADE_AUSWAHLWERTE_MODULUNTERRICHT](context) {
      let responseAppApi = await AppApi.get("auswahlwerte/modulunterricht/");
      context.commit(SET_ABSCHLUSS, responseAppApi.data.abschluss);
      context.commit(SET_ANZEIGEMODUS, responseAppApi.data.anzeigemodus);
    },
  },
};
